import { StateValue } from '@/types';

type ResolveValue = <T>(prev: T, newValue: StateValue<T>) => T;

export const resolveValue: ResolveValue = (prev, value) => {
    if (value instanceof Function) return value(prev);
    return value;
};
